import {BaseCachedService} from './Core/BaseCachedService';

class StateService extends BaseCachedService {
    get Url() { return super.Url + "/states"; }
    get ModelName() { return "State"; }
    get PrimaryKeyProperty() { return "stateId"; }
}

export const service = new StateService();

